

import colors from "../../utils/colors";

// use styles object because react-dropzone package accepts only inline styles
export var baseStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 1,
  borderRadius: 6,
  borderColor: colors.neutral[600],
  borderStyle: 'dashed',
  color: colors.neutral[800],
  outline: 'none',
  fontSize: '1.6rem',
  lineHeight: '2.4rem',
  minHeight: '14rem',
  textAlign: 'center'
};

export var activeStyle = {
  borderColor: colors.blue[500]
};

export var acceptStyle = {
  color: colors.green[500],
  borderColor: colors.green[500]
};

export var rejectStyle = {
  color: colors.red[500],
  borderColor: colors.red[500]
};

export var acceptedFileItem = {
  display: 'flex',
  listStyle: 'none',
  fontSize: '1.6rem',
  alignItems: 'center',
  marginBottom: '0.5rem',
  wordBreak: 'break-word',
  gap: '1rem'
};

export var removeFileButton = {
  display: 'flex',
  marginLeft: 'auto'
};

export var filesListTitle = {
  fontSize: '1.6rem',
  color: colors.neutral[800],
  margin: 0
};

export var errorMessage = {
  fontSize: '1.4rem',
  color: colors.red[500],
  marginTop: '0.5rem'
};

export var fileNameStyle = {
  margin: 0
};

export var acceptedFilesWrapper = {
  marginTop: '1rem'
};

export var rejectedFilesWrapper = {
  marginTop: '1.5rem'
};

export var filesList = {
  padding: 0
};
//# sourceMappingURL=styles.js.map